import { scrollAndHighlightField } from './scroll_to_field_util'

export default {
  data() {
    return {
      numericErrors: {},
    }
  },
  created() {
    this._numericTimers = {}
  },
  methods: {
    numericState(key) {
      return this.numericErrors[key] ? false : null
    },
    numericFeedback(key) {
      return this.numericErrors[key] || ''
    },
    blockNonNumericKeys(event, integerOnly) {
      const blocked = integerOnly
        ? ['e', 'E', '+', '-', '.']
        : ['e', 'E', '+']
      if (blocked.includes(event.key)) event.preventDefault()
    },
    validateNumeric(key, value, min, max, integerOnly) {
      if (this._numericTimers[key]) clearTimeout(this._numericTimers[key])
      if (!this._numericPendingArgs) this._numericPendingArgs = {}
      this._numericPendingArgs[key] = { value, min, max, integerOnly }
      this._numericTimers[key] = setTimeout(() => {
        if (this._numericPendingArgs) delete this._numericPendingArgs[key]
        if (value === '' || value === null || value === undefined) {
          this.$set(this.numericErrors, key, '')
          return
        }
        const num = Number(value)
        if (isNaN(num)) {
          this.$set(this.numericErrors, key, `Must be a number (${min} – ${max})`)
        } else if (integerOnly && !Number.isInteger(num)) {
          this.$set(this.numericErrors, key, `Must be a whole number (${min} – ${max})`)
        } else if (num < min || num > max) {
          this.$set(this.numericErrors, key, `Must be between ${min} and ${max}`)
        } else {
          this.$set(this.numericErrors, key, '')
        }
      }, 1000)
    },
    hasNumericErrors() {
      return Object.values(this.numericErrors).some(e => !!e)
    },
    firstNumericErrorKey() {
      return Object.keys(this.numericErrors).find(k => !!this.numericErrors[k])
    },
    flushNumericValidation() {
      if (!this._numericPendingArgs) this._numericPendingArgs = {}
      Object.keys(this._numericTimers || {}).forEach(key => {
        clearTimeout(this._numericTimers[key])
        delete this._numericTimers[key]
      })
      Object.entries(this._numericPendingArgs).forEach(([key, { value, min, max, integerOnly }]) => {
        if (value === '' || value === null || value === undefined) {
          this.$set(this.numericErrors, key, '')
          return
        }
        const num = Number(value)
        if (isNaN(num)) {
          this.$set(this.numericErrors, key, `Must be a number (${min} – ${max})`)
        } else if (integerOnly && !Number.isInteger(num)) {
          this.$set(this.numericErrors, key, `Must be a whole number (${min} – ${max})`)
        } else if (num < min || num > max) {
          this.$set(this.numericErrors, key, `Must be between ${min} and ${max}`)
        } else {
          this.$set(this.numericErrors, key, '')
        }
      })
      this._numericPendingArgs = {}
    },
    scrollToFirstNumericError() {
      scrollAndHighlightField(this, this.firstNumericErrorKey())
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.numericErrors = {}
        if (this._numericTimers) {
          Object.values(this._numericTimers).forEach(t => clearTimeout(t))
          this._numericTimers = {}
        }
        this._numericPendingArgs = {}
      }
    }
  },
  beforeDestroy() {
    if (this._numericTimers) {
      Object.values(this._numericTimers).forEach(t => clearTimeout(t))
    }
  }
}
